var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLocation = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4717 10.1163C12.4246 9.04569 13 7.66364 13 6.15378C13 2.7552 10.0898 0 6.5 0C2.91021 0 0 2.7552 0 6.15378C0 7.66364 0.57517 9.04569 1.52834 10.1163L6.5 16L11.4717 10.1163ZM6.5 4.2256C7.6248 4.2256 8.53685 5.08889 8.53685 6.15378C8.53685 7.21867 7.62499 8.08213 6.5 8.08213C5.37501 8.08213 4.46296 7.21884 4.46296 6.15378C4.46296 5.08889 5.3752 4.2256 6.5 4.2256Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location.5e21f0a6.svg";
export { ForwardRef as ReactComponent };